export class WorkItemReplayInput{
   
    public crmUserId:number;
   
    public sessionToken:string;

    public emailAddress:string;
    
    public workITemId:number;
 }